module.exports = __webpack_public_path__ + "img/doctor.d45b59fa.svg";